import { render, staticRenderFns } from "./SomethingMissing.vue?vue&type=template&id=7b211b2c&lang=pug"
import script from "./SomethingMissing.vue?vue&type=script&lang=js"
export * from "./SomethingMissing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports